<div class="home-folders-accordion-container">
  <!-- Component Title -->
  <div class="component-title">
    <h2 style="font-size: 18px;">
      <mat-icon class="title-icon">
        business
      </mat-icon>
      Shared files from other hospitals
    </h2>
    <mat-divider></mat-divider>
  </div>

  <!-- Loading overlay -->
  <div *ngIf="loading"
       class="loading-overlay">
    <mat-progress-spinner diameter="40"></mat-progress-spinner>
    <p class="loading-message">
      {{loadingMessage}}
    </p>
  </div>

  <!-- Spoke folders accordion -->
  <mat-accordion class="folders-accordion"
                 multi="false">
    <mat-expansion-panel *ngFor="let folder of displayFolders; trackBy: trackByFolderId"
                         #folderItem
                         class="folder-panel"

                         [class.spoke-folder]="folder.type === 'spoke'"
                         [expanded]="isExpanded(folder)"

                         (closed)="checkAndEmitAllFoldersClosed()"
                         (opened)="handleFolderExpansion(folder)">
      <!-- Panel header -->
      <mat-expansion-panel-header class="folder-header">
        <mat-panel-title class="folder-title">
          <mat-icon class="folder-icon"
                    [style.color]="getFolderColor(folder)">
            {{ getFolderIcon(folder) }}
          </mat-icon>
          <span class="folder-name">
            {{getFolderDisplayName(folder)}}
          </span>
          <span *ngIf="folder.count"
                class="folder-count">
            {{folder.count}}
          </span>
          <mat-icon *ngIf="folder.hasNotifications"
                    class="notification-icon"
                    color="warn">
            notifications_active
          </mat-icon>
        </mat-panel-title>

        <mat-panel-description class="folder-description">
        </mat-panel-description>
      </mat-expansion-panel-header>

      <!-- Panel content - Files list -->
      <div *ngIf="isExpanded(folder)"
           class="folder-content">
        <!-- Loading indicator -->
        <div *ngIf="folder.loading"
             class="folder-loading">
          <mat-progress-spinner diameter="30"></mat-progress-spinner>
          <p>
            Loading files...
          </p>
        </div>

        <!-- No files message -->
        <div *ngIf="!folder.loading && (!folder.files || folder.files.length === 0)"
             class="no-files-message">
          <mat-icon>
            folder_open
          </mat-icon>
          <p>
            No files shared from this spoke
          </p>
        </div>

        <!-- Files table -->
        <div *ngIf="!folder.loading && folder.files && folder.files.length > 0"
             class="files-table-container">
          <!-- Files table -->
          <table class="files-table">
            <thead>
              <tr>
                <th class="file-name-column">
                  File Name
                </th>
                <th class="file-date-column">
                  Date of File
                </th>
                <th class="file-size-column">
                  File Size
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of getPaginatedFiles(folder); trackBy: trackByFileId"
                  class="file-row">
                <td class="file-name-cell"
                    (click)="onFileClick(file, $event)">
                  <div class="file-name-content">
                    <mat-icon class="file-icon"
                              [style.color]="file.color || getFolderColor(folder)">
                      {{ isDicomFile(file) ? 'medical_services' : 'description' }}
                    </mat-icon>
                    <div class="file-name-details">
                      <span class="file-name">
                        {{file.fileName}}
                      </span>
                      <div class="file-icons">
                        <mat-icon *ngIf="file.hasNotifications"
                                  class="file-notification-icon"
                                  color="warn"
                                  matTooltip="This file has notifications">
                          notifications_active
                        </mat-icon>
                        <mat-icon *ngIf="file.hasCommentAttachments"
                                  class="file-comment-icon"
                                  color="primary"
                                  matTooltip="This file has comments/attachments">
                          comment
                        </mat-icon>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="file-date-cell"
                    (click)="onFileClick(file, $event)">
                  {{ formatFileDateTime(file.fdate, file.ftime) }}
                </td>
                <td class="file-size-cell"
                    (click)="onFileClick(file, $event)">
                  {{ file.fileSize | fileSize }}
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination controls -->
          <div *ngIf="folder.files.length > defaultPageSize"
               class="pagination-controls">
            <button mat-icon-button
                    [disabled]="getPaginationState(folder.id).currentPage === 1"
                    (click)="onPageChange(folder.id, getPaginationState(folder.id).currentPage - 1)">
              <mat-icon>
                chevron_left
              </mat-icon>
            </button>

            <span class="page-info">
              Page {{ getPaginationState(folder.id).currentPage }} of {{ getPaginationState(folder.id).totalPages }}
            </span>

            <button mat-icon-button
                    [disabled]="getPaginationState(folder.id).currentPage === getPaginationState(folder.id).totalPages"
                    (click)="onPageChange(folder.id, getPaginationState(folder.id).currentPage + 1)">
              <mat-icon>
                chevron_right
              </mat-icon>
            </button>

            <mat-form-field class="page-size-selector">
              <mat-label>
                Items per page
              </mat-label>
              <mat-select [value]="getPaginationState(folder.id).pageSize"
                          (selectionChange)="onPageSizeChange(folder.id, $event.value)">
                <mat-option *ngFor="let size of getPageSizeOptions()"
                            [value]="size">
                  {{ size }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Empty state -->
  <div *ngIf="displayFolders.length === 0"
       class="empty-state">
    <mat-icon>
      business_center
    </mat-icon>
    <h3>
      No Spokes Available
    </h3>
    <p>
      No facilities have shared files with this hub yet.
    </p>
  </div>
</div>
